// Libs
import React from "react";

// Local
import EmailImagesPage from "./EmailImagesPage";
import { useSiteKeyDocStore } from "../../store/site-key-doc";

export default function EmailImagesContainer() {
  const siteKey = useSiteKeyDocStore((state) => state.siteKeyDoc);

  if (!siteKey) {
    return <div>Loading...</div>;
  }

  return <EmailImagesPage siteKey={siteKey.id} />;
}
